import axiosLib, { AxiosError, AxiosInstance, AxiosResponse } from 'axios'
import { Analytics } from '../analytics'

interface AnalyticsEvent {
  pageName: string
  eventType?: string
  eventAction?: string
  errorMessage?: string
}

interface AnalyticsData {
  [statusCode: number]: AnalyticsEvent
}

const analyticsTrack = (
  url: string,
  errorCode: number,
  errorMessage: string
): void => {
  const analyticsData: AnalyticsData = {
    401: {
      pageName: 'Error: Unauthorized (401)',
      eventType: 'Login',
      eventAction: 'Unauthorized',
      errorMessage: 'Unauthorized',
    },
    403: {
      pageName: 'Error: Access denied (403)',
      eventType: 'Access',
      eventAction: 'Denied',
      errorMessage: 'Access denied',
    },
    404: {
      pageName: 'Error: Page not found (404)',
      errorMessage: 'Page not found',
    },
    500: {
      pageName: 'Error: Internal server error (500)',
    },
  }

  const data = analyticsData[errorCode] || {
    pageName: `Error: Unknown (${errorCode})`,
    eventAction: 'Unknown error',
  }

  Analytics.setTrackingData({
    [Analytics.keys.pageName()]: data.pageName,
    [Analytics.keys.viewChange()]: 'Error',
    [Analytics.keys.eventType(0)]: data.eventType || 'Error',
    [Analytics.keys.eventAction(0)]: data.eventAction || 'Technical error',
    [Analytics.keys.errorCode()]: errorCode,
    [Analytics.keys.errorMessage()]: data.errorMessage || errorMessage,
    [Analytics.keys.errorCausingURL()]: url,
  })

  Analytics.trackPage()
}

const axios: AxiosInstance = axiosLib.create({
  baseURL: process.env.REACT_APP_API_GATEWAY,
})

axios.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    const status = error.response?.status
    const url = error.config?.url
    const message = error.message

    if (status && url) {
      analyticsTrack(url, status, message)
    }

    return Promise.reject(error)
  }
)

export default axios
